import Home from '@/pages/Home'
import LayoutContent from '@/components/layouts/LayoutContent'
import WatchPortfolio from '../pages/WatchPortfolio'
import NotFoundPage from '../pages/NotFoundPage'

export default [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/content',
    name: 'Content',
    component: LayoutContent,
    redirect: { name: 'Services' }
  },
  {
    path: '/services/:serviceType',
    name: 'ServiceType',
    props: true,
    component: LayoutContent,
    children: [
      {
        path: ':serviceId',
        name: 'ServiceTypeId',
        props: true,
        component: WatchPortfolio
      }
    ]
  },
  {
    path: '/services',
    name: 'Services',
    component: LayoutContent
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: LayoutContent
  },
  {
    path: '/contact',
    name: 'Contact',
    component: LayoutContent
  },
  {
    path: '/gratitude',
    name: 'Gratitude',
    component: LayoutContent
  },
  {
    path: '*',
    name: 'NotFoundPage',
    component: NotFoundPage
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js